module.exports = __webpack_public_path__ + "img/telcell.1183f0d3.png";